import { Component, OnInit } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { PopupsService } from 'src/app/core/services/popups.service';
import { VersionService } from 'src/app/core/services/version.service';
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    imports: [IonicModule, TranslateModule]
})
export class AboutComponent {

  public buildVersion: string;
  public usingDarkTheme = window.matchMedia('(prefers-color-scheme: dark)').matches;

  constructor(private translate: TranslateService,
              private popupsSrv: PopupsService,
              private versionService: VersionService,
              private modalController: ModalController
            ){
    this.buildVersion = versionService.getBuildVersion();
    addIcons({ close });
  }

  public copyMessage(val: string): void {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.translate.get('OnClipboard').subscribe((message) => {
      this.popupsSrv.presentToast(message, 4000, 'top');
    });
  }

  public onExtLinkClick(siteName: string): void {
    this.translate.get(siteName + 'Site').subscribe(url => {
      window.open(url, '_blank');
    });
  }

  public closemodal() {
    this.modalController.dismiss();
  }
}
